<div class="wrapper-content">
  <div class="content">
    <div class="modal-body">
      <div class="container-fluid">
        <div class="row d-flex justify-content-end">
          <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
        </div>
          <ng-container *ngIf="director$ | async as director">
            <app-directorship-profile [director]="director" [directorship]="directorship"></app-directorship-profile>
          </ng-container>
      </div>

    </div>
  </div>
</div>
